// Lee la primera hoja de un Excel (.xlsx) o un CSV como filas de texto: la primera fila son los titulos de columna.
// Los formatos de ejemplo para cargar en bloque viven en public/formatos (contactos, usuarios, invitados).
import readXlsxFile from 'read-excel-file';

import { decodificar, filasCsv } from './libreta';

export const esExcel = (nombre: string) => /\.xlsx$/i.test(nombre);

export async function filasDeArchivo(archivo: File): Promise<string[][]> {
  if (!esExcel(archivo.name)) return filasCsv(decodificar(await archivo.arrayBuffer()));
  const filas = await readXlsxFile(archivo);
  return filas
    .map((f) => f.map((c) => (c == null ? '' : c instanceof Date ? c.toISOString().slice(0, 10) : String(c)).trim()))
    .filter((f) => f.some(Boolean));
}

/** Indice de la primera columna cuyo titulo (sin tildes ni mayusculas) coincide con alguno de los nombres. */
export function columna(titulos: string[], nombres: string[]) {
  const t = titulos.map((h) => h.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim());
  for (const n of nombres) {
    const i = t.indexOf(n.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase());
    if (i >= 0) return i;
  }
  return -1;
}
